export enum LoadingStatus {
    PENDING = 'Pending',
    START = 'Start',
    IN_PROGRESS = 'In Progress',
    READY = 'Ready'
}